import { style } from '@vanilla-extract/css'

export const note = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#828282',
  textAlign: 'center',
})

export const card = style({
  borderRadius: '16px',
  padding: '16px',
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  width: '100%',
})

export const cardHeading = style({
  fontSize: '15px',
  fontWeight: '700',
})

export const statusLabel = style({
  display: 'inline-block',
  backgroundColor: '#eeeeee',
  borderRadius: '4px',
  padding: '2px 6px',
  fontSize: '12px',
  fontWeight: '700',
  lineHeight: '1.5',
})

export const scheduledDate = style({
  width: '100%',
  fontSize: '14px',
  lineHeight: '1',
  padding: '16px 0',
  selectors: {
    '&:not(:last-child)': {
      borderBottom: 'solid 1px #eeeeee',
    }
  }
})

export const warn = style({
  fontSize: '13px',
  fontWeight: '700',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#ED0006',
})
